import { Button, Modal } from 'react-bootstrap';

interface IProps {
    show: boolean,
    alias: string,
    fullName: string,
    onConfirmed: () => void,
    onCancel: () => void
}

const WithdrawDonor = (props: IProps) => {
    return (
        <Modal backdrop='static' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>
                Confirm Withdrawal of Donor
            </Modal.Header>
            <Modal.Body>
                Are you sure you wish to withdraw this donor?<br /><br />

                <blockquote>
                    Alias: {props.alias}<br />
                    Name: {props.fullName}
                </blockquote>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={props.onConfirmed}>Yes, Confirmed</Button>
                <Button onClick={props.onCancel}>No, Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default WithdrawDonor;